
// 存储列表从详情页带来的查询信息

const reportParams = {
    state: {
        params: {}
    },
    mutations:{
        SET_REPORTPARAMS: (state, configPath, querys) => {

            state.params = configPath
        }
    },
    actions:{
        ReportParams({commit}, configPath) {
            console.log(configPath)
            commit('SET_REPORTPARAMS', configPath)
        }
    }
}

export default reportParams


// WEBPACK FOOTER //
// ./src/store/modules/report.js